import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8eb84c6e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb84c6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eb84c6e')) {
      api.createRecord('8eb84c6e', component.options)
    } else {
      api.reload('8eb84c6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8eb84c6e&scoped=true", function () {
      api.rerender('8eb84c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditcenter/index.vue"
export default component.exports